import { Injectable } from '@angular/core';
import { SearchStateService } from './search-state.service';
import { ReqService } from './req.service';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { Breakdown } from '@core/models/breakdown/breakdown.interface';
@Injectable()
export class DetailService {
  constructor(
    private http: HttpClient,
    private reqService: ReqService,
    private searchStateService: SearchStateService,
  ) {}

  /**
   * Gets the hotel availability information asynchronously
   * @return {Observable}
   */
  public getHotelDetail(chain?: string): Observable<any> {
    let chainQuery = '';
    if (chain && chain.toLowerCase() !== 'n/a') {
      chainQuery = '&chain=' + chain.toLowerCase();
    }

    return this.http.get(
      `/hotels/async/detail/${this.searchStateService.getSlugId()}${this.searchStateService.getQueryString()}&includeDetails=false${chainQuery}`,
    );
  }
  /**
   * Gets the hotel breakdown information
   * @return {Observable}
   */
  public getHotelBreakdown(rate_id?: string, currencyCode?: string): Observable<Breakdown> {
    const bodyReq = {
      rateId: rate_id,
      currencyCode,
    };
    return this.http.post(`/hotels/async/breakdown`, bodyReq);
  }

  public getRateInfo(rateId: string): Observable<any> {
    return this.http.get(`/hotels/async/rate/${rateId}/info`);
  }

  /**
   * Gets catalog entity from the current search
   * @return {Observable}
   */
  public getEntity(entityType: string, entityId: string): Observable<any> {
    return this.http.get(`/hotels/async/catalog/${entityType}/${entityId}`);
  }

  /**
   * Get all translations for text by language
   * @param {string[]} dataToTranslate
   * @return {Observable<string[]>}
   */
  public getTranslations(dataToTranslate: string[]): Observable<string[]> {
    const locale: string = this.reqService.getLocale();
    const language: string = locale.substring(0, locale.indexOf('-'));
    return this.http.post<string[]>(`/hotels/async/translations/${language}`, {
      text: dataToTranslate,
    });
  }
}
